module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921115334_T.db7e8c7d.jpg";